import { render, staticRenderFns } from "./GColumnChart.vue?vue&type=template&id=41889cc0&"
import script from "./GColumnChart.vue?vue&type=script&lang=js&"
export * from "./GColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports